import { BuilderProfileSchema } from "@amzn/aws-marketing-identity-kit-profile-schema";
export const BPschema = BuilderProfileSchema;
export const FormConfig = {
    alias: { label: "Alias" },
    bio: { label: "Bio" },
    businessEmail: { label: "Business Email" },
    firstName: { label: "First Name" },
    lastName: { label: "Last Name" },
    phone: { label: "Phone" },
    company: { label: "Company" },
    countryRegion: { label: "Country/Region" },
    stateProvince: { label: "State/Province" },
    postalCode: { label: "Postal Code" },
    industry: { label: "Industry" },
    jobRole: { label: "Job Role" },
    jobTitle: { label: "Job Title" },
    usageLevel: { label: "Usage Level" },
    useCase: { label: "Use Case" },
    interestReason: { label: "Interest Reason" },
    city: { label: "City" },
    companySize: { label: "Company Size" },
    companyType: { label: "Company Type" },
    projectTimeFrame: { label: "Project Time Frame" },
    complianceOptIn: { label: "Compliance Opt In" },
    complianceRequesterType: { label: "Compliance Requester Type" },
    social: { label: "Social" },
    link: { label: "Link" },
};
export const CommunityFields = [
    "displayName",
    "alias",
    "bio",
    "social",
];
export const UserFields = [
    "firstName",
    "lastName",
    "personalEmailAddress",
];
export const InterestsFields = [
    "interests",
    "countryRegion",
    "jobRole",
    "industry",
    "usageLevel",
    "useCase",
];
export const WorkInfoFields = [
    "businessEmail",
    "phone",
    "jobTitle",
    "postalCode",
    "companyName",
    "companyType",
    "companySize",
    "projectTimeFrame",
];
export const InterestOptions = [
    "Machine Learning & AI",
    ".NET",
    "API Gateway",
    "APP Config",
    "AR/VR",
    "Alexa",
    "Amplify",
    "Amazon Q",
    "Analytics",
    "Apache Airflow",
    "Apache Kafka",
    "Apache",
    "App Mesh",
    "App Runner",
    "App Studio",
    "App2Container",
    "AppFabric",
    "AppFlow",
    "AppStream 2.0",
    "AppSync",
    "Application Composer",
    "Application Discovery Service",
    "Application Integration",
    "Application Migration Service",
    "Architecture Strategy",
    "Artifact",
    "Artificial Intelligence",
    "Athena",
    "Audit Manager",
    "Aurora",
    "Auto Scaling",
    "Backup",
    "Bash",
    "Batch",
    "Bedrock",
    "Billing Conductor",
    "Blockchain",
    "Braket",
    "Budgets",
    "Business Applications",
    "C#",
    "C/C++",
    "CSS",
    "Certificate Manager",
    "Chatbot",
    "Chime",
    "Clean Rooms",
    "Cloud Control API",
    "Cloud Development Kit (CDK)",
    "Cloud Directory",
    "Cloud Financial Management",
    "Cloud Foundations",
    "Cloud Map",
    "Cloud WAN",
    "Cloud9",
    "CloudEndure",
    "CloudFormation",
    "CloudFront",
    "CloudHSM",
    "CloudSearch",
    "CloudShell",
    "CloudTrail",
    "CloudWatch",
    "CodeArtifact",
    "CodeBuild",
    "CodeCatalyst",
    "CodeCommit",
    "CodeDeploy",
    "CodeGuru",
    "CodePipeline",
    "CodeStar",
    "Cognito",
    "Compliance",
    "Comprehend",
    "Compute Optimizer",
    "Compute",
    "Config",
    "Connect",
    "Contact Center",
    "Containers",
    "Control Tower",
    "Copilot",
    "Corretto",
    "Cost Explorer",
    "Dash",
    "Data Exchange",
    "Data Integration",
    "Data Pipeline",
    "DataSync",
    "DataZone",
    "Database Migration Service (DMS)",
    "Databases",
    "Deadline Cloud",
    "Deep Learning",
    "DeepComposer",
    "DeepLens",
    "DeepRacer",
    "Detective",
    "DevOps Guru",
    "Developer Tools",
    "Device Farm",
    "Direct Connect",
    "Directory Service",
    "Distro for OpenTelemetry",
    "DocumentDB",
    "DynamoDB",
    "EC2",
    "EMR",
    "ElastiCache",
    "Elastic Beanstalk",
    "Elastic Block Storage (EBS)",
    "Elastic Container Registry (ECR)",
    "Elastic Container Service (ECS)",
    "Elastic Disaster Recovery (DRS)",
    "Elastic File System (EFS)",
    "Elastic Inference",
    "Elastic Kubernetes Service (EKS)",
    "Elastic Transcoder",
    "Elemental",
    "End-User Computing (EUC)",
    "EventBridge",
    "FSx",
    "Fargate",
    "Fault Injection Simulator",
    "File Cache",
    "FinSpace",
    "Firewall Manager",
    "Forecast",
    "Fraud Detector",
    "FreeRTOS",
    "Front-End Development",
    "GameKit",
    "GameLift",
    "GameSparks",
    "Games",
    "Generative AI",
    "Global Accelerator",
    "Glue",
    "Go",
    "Ground Station",
    "GuardDuty",
    "HTML",
    "Health",
    "HealthLake",
    "High Performance Computing (HPC)",
    "IAM Identity Center",
    "IAM",
    "Identity Management",
    "Inferentia",
    "Inspector",
    "Interactive Video Service",
    "Internet of Things (IoT)",
    "Java",
    "JavaScript",
    "Kendra",
    "Key Management Service (KMS)",
    "Kinesis",
    "Kotlin",
    "Lake Formation",
    "Lambda",
    "Launch Wizard",
    "Lex",
    "License Manager",
    "Lightsail",
    "Local Zones",
    "Location Service",
    "Lookout",
    "Lumberyard",
    "MQ Message Broker",
    "Machine Learning",
    "Macie",
    "Mainframe Modernization",
    "Managed Blockchain",
    "Managed Grafana",
    "Management & Governance",
    "Media Services",
    "Migration",
    "Mobile",
    "Monitron",
    "Neptune",
    "Network Firewall",
    "Networking & Content Delivery",
    "Networking",
    "Neuron",
    "Nimble Studio",
    "Objective-C",
    "One",
    "OpenSearch Service (OSS)",
    "OpenShift",
    "OpsWorks",
    "Organizations",
    "Outposts",
    "PHP",
    "Panorama",
    "Perl",
    "Personalize",
    "Pinpoint",
    "Polly",
    "PowerShell",
    "Private 5G",
    "Private Certificate Authority",
    "PrivateLink",
    "Prometheus",
    "Proton",
    "Python",
    "Q",
    "Quantum Solutions Lab",
    "Quantum Technologies",
    "QuickSight",
    "RDS",
    "Redshift",
    "Rekognition",
    "rePost Private",
    "Resilience Hub",
    "Resource Access Manager",
    "RoboMaker",
    "Robotics",
    "Route 53",
    "Ruby",
    "Rust",
    "S3",
    "SAP ABAP",
    "SQL",
    "SageMaker",
    "Satellite",
    "Secrets Manager",
    "Security Hub",
    "Security Lake",
    "Security",
    "Security, Identity, & Compliance",
    "Server Migration Service (SMS)",
    "Serverless Application Repository",
    "Serverless",
    "Service Catalog",
    "Service Management Connector",
    "Shield",
    "Simple Email Service (SES)",
    "Simple Notification Service (SNS)",
    "Simple Queue Service (SQS)",
    "Simspace Weaver",
    "Single Sign-On (SSO)",
    "Snow Family",
    "Snowball",
    "Snowcone",
    "Snowmobile",
    "Step Functions",
    "Storage Gateway",
    "Storage",
    "Sumerian",
    "Supply Chain",
    "Swift",
    "Systems Manager",
    "Telco Network Builder",
    "TensorFlow",
    "Textract",
    "Thinkbox",
    "Timestream",
    "Titan",
    "Transcribe",
    "Translate",
    "Trusted Advisor",
    "TypeScript",
    "VMware",
    "Verified Access",
    "Verified Permissions",
    "Virtual Private Cloud (VPC)",
    "Virtual Private Network (VPN)",
    "Wavelength",
    "Web Application Firewall (WAF)",
    "WebApps",
    "Wickr",
    "WorkDocs",
    "WorkLink",
    "WorkMail",
    "WorkSpaces",
    "X-Ray",
];
export var SocialMediaKeys;
(function (SocialMediaKeys) {
    SocialMediaKeys["github"] = "github";
    SocialMediaKeys["facebook"] = "facebook";
    SocialMediaKeys["linkedIn"] = "linkedIn";
    SocialMediaKeys["devto"] = "devto";
    SocialMediaKeys["youtube"] = "youtube";
    SocialMediaKeys["repost"] = "repost";
    SocialMediaKeys["blog"] = "blog";
    SocialMediaKeys["twitter"] = "twitter";
})(SocialMediaKeys || (SocialMediaKeys = {}));
export const SocialMediaOptions = [
    { key: "Github", value: SocialMediaKeys.github.valueOf() },
    { key: "Facebook", value: SocialMediaKeys.facebook.valueOf() },
    { key: "LinkedIn", value: SocialMediaKeys.linkedIn.valueOf() },
    { key: "Dev.to", value: SocialMediaKeys.devto.valueOf() },
    { key: "Youtube", value: SocialMediaKeys.youtube.valueOf() },
    { key: "re:Post", value: SocialMediaKeys.repost.valueOf() },
    { key: "Blog", value: SocialMediaKeys.blog.valueOf() },
    { key: "X", value: SocialMediaKeys.twitter.valueOf() },
];
export const CountryOptions = BuilderProfileSchema.countryRegion.items;
export const IndustryOptions = BuilderProfileSchema.industry.items;
export const displayCountryOptions = [
    { key: "Select display country", value: "" },
    ...CountryOptions,
];
export const JobRoleOptions = BuilderProfileSchema.jobRole.items;
export const UsageLevelOptions = BuilderProfileSchema.usageLevel.items;
export const UseCaseOptions = BuilderProfileSchema.useCase.items;
export const InterestReasonOptions = BuilderProfileSchema.interestReason.items;
export const CompanySizeOptions = BuilderProfileSchema.companySize.items;
export const CompanyTypeOptios = BuilderProfileSchema.companyType.items;
export const ProjectTimeFrameOptions = BuilderProfileSchema.projectTimeFrame.items;
export const USStates = BuilderProfileSchema.stateProvince_US.items;
export const CAStates = BuilderProfileSchema.stateProvince_CA.items;
export const AUStates = BuilderProfileSchema.stateProvince_AU.items;
export const CNStates = BuilderProfileSchema.stateProvince_CN.items;
export const BRStates = BuilderProfileSchema.stateProvince_BR.items;
export const DEStates = BuilderProfileSchema.stateProvince_DE.items;
export const HKStates = BuilderProfileSchema.stateProvince_HK.items;
export const INStates = BuilderProfileSchema.stateProvince_IN.items;
export const StatesMap = {
    US: USStates,
    CA: CAStates,
    AU: AUStates,
    CN: CNStates,
    BR: BRStates,
    DE: DEStates,
    HK: HKStates,
    IN: INStates,
};
export const EmailTypes = [
    { value: "Personal", key: "Personal" },
    { value: "Business", key: "Business" },
];
export const EmailOptions = [{ value: "delete", key: "Delete" }];
export const EmailBIOptions = [
    { value: "manage", key: "Manage my AWS Builder ID" },
];
export const EmailDefaultLocale = "en_US";
//# sourceMappingURL=form-fields.js.map